import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputModule } from 'experian-shared-frontend';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-tour',
    templateUrl: 'tour.component.html',
    styleUrls: ['tour.component.scss'],
    imports: [CommonModule, InputModule, ReactiveFormsModule, FormsModule]
})
export class TourMockupComponent {
  @Input() isTouring: boolean;
  
  public form: FormGroup;
  private readonly fb = inject(FormBuilder);

  constructor() {
    this.form = this.fb.group({
      fakeInput: [''],
    });
  }
}
